import { Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { RouteCMRAgentRoutePartECMRDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentRoutePartECMRDto';
import { RoutePartCMRBaseDto } from '@shared/src/dtos/route/cmr/RoutePartCMRBaseDto';
import { AlertService, HString } from '@shared/src/public-api';

@Component({
    selector: 'shared-external-cmr-agent-listcmrs',
    templateUrl: './shared.external.cmr.agent.listcmrs.component.html',
    styleUrls: ['./shared.external.cmr.agent.listcmrs.component.scss']
})
export class SharedExternalCMRAgentListCMRsComponent implements OnInit {
   
    public useIonic: boolean = false;
    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    ngOnInit(): void {
    }

    public __uuidQR: string;
    @Input()
    public set uuidQR(value: string) {
        if (this.__uuidQR === value)
            return;
        this.__uuidQR = value;
        this.loadData();
    }
    public get uuidQR(): string {
        return this.__uuidQR;
    }
    
    public __phaseUUID: string;
    @Input()
    public set phaseUUID(value: string) {
        if (this.__phaseUUID === value)
            return;
        this.__phaseUUID = value;
        this.loadData();
    }
    public get phaseUUID(): string {
        return this.__phaseUUID;
    }

    public __agent: RouteCMRAgents;
    @Input()
    public set agent(value: RouteCMRAgents) {
        if (this.__agent === value)
            return;
        this.__agent = value;
        this.loadData();
    }
    public get agent(): RouteCMRAgents {
        return this.__agent;
    }

    public __value: RouteCMRAgentRoutePartECMRDto[];
    public set value(value: RouteCMRAgentRoutePartECMRDto[]) {
        if (this.__value === value)
            return;
        this.__value = value;
        if(value != null && value.length == 1)
            this.routePartCMR = value[0].routePartCMR;
    }
    public get value(): RouteCMRAgentRoutePartECMRDto[] {
        return this.__value;
    }
    loadData() {
        if(RouteCMRAgentsEnum.isValid(this.agent)){
            if (!HString.isNullOrNullString(this.phaseUUID)) {
                this.openRouteCMRController.getRouteCMRAgentListECMRsByPhaseUUID(this.phaseUUID, this.agent).subscribe(data => { 
                    this.value = data;
                });
            } else if(!HString.isNullOrNullString(this.uuidQR)) {
                this.openRouteCMRController.getRouteCMRAgentListECMRsByUUID(this.uuidQR, this.agent).subscribe(data => { 
                    this.value = data;
                });
            }
        }
    }
    
    public getResourceControlDocument(): string{
        if(this.value == null || this.value.length == 0)
            return "";
        if(this.value.length == 1)
            return 'SHARED.EXTERNAL.CMR.SHOWCONTROLDOCUMENT.CAPTION';
        return 'SHARED.EXTERNAL.CMR.SHOWCONTROLDOCUMENTS.CAPTION';
    }
    
    public routePartCMR: RoutePartCMRBaseDto;
    onClickLinkCMR(value: RouteCMRAgentRoutePartECMRDto) {
        this.routePartCMR = value.routePartCMR;
    }

    onDocumentValueChanged(){
        
    }
    public collapse(): boolean {
        if(this.value != null && this.value.length == 1)
            return false;
        
        if (this.routePartCMR != null) {
            this.routePartCMR = null;
            return true;
        }
        return false;
    }
    
    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
